import { getIn, useFormikContext } from "formik"

import * as Yup from 'yup'

import { FormikFileUpload, FormikDateSelector, FormikInspectorAgreeCheck, billingDetailsSchema, FormikBillingDetails, FormikNotesArea } from "../../../../../../components/widgets"
import { useEffect } from "react"
import { IWebFileAttachment } from "../../../../../core/applications"

export interface IDLMTestResult  {
  verdict: string, 
  workflow: string,
  note: string
  noteAttachments: Array<IWebFileAttachment>
  inspectionDate: string    
  inspectionResultId: number
  inspectionResultIdAttachmentName: string
  labTestAttachmentId: number
  labTestAttachmentIdAttachmentName: string
  inspectorAgree: boolean   
}

export const initDLMTestResultValues = {
  verdict: '', 
  workflow: '',
  note: '',
  noteAttachments: [],      
  inspectionDate: '',
  inspectionResultId: 0,
  inspectionResultIdAttachmentName: '',
  labTestAttachmentId: 0,
  labTestAttachmentIdAttachmentName: '',
  inspectorAgree: false,    
}

export const DLMTestResultSchema: any = Yup.object({
  verdict: Yup.string().trim(),
  workflow: Yup.string().trim(),
  note: Yup.string().trim().label('Note')
  .when('verdict', {
    is : (verdict: string) => (verdict !== 'approved'),
    then: (schema) => schema.required(),    
  }),  
  noteAttachments: Yup.array(),  
  inspectionDate: Yup.string().trim().label('Inspection Date')
  .when(['workflow', 'verdict'], {
    is : (workflow: string, verdict: string) => ((workflow === 'Label1b1'|| workflow === 'Label1b2') && verdict === 'approved'),
    then: (schema) => schema.required(),    
  }),            
  inspectionResultId: Yup.number().integer().label('Inspection Result')
  .when(['workflow', 'verdict'], {
    is : (workflow: string, verdict: string) => ((workflow === 'Label1b1'|| workflow === 'Label1b2') && verdict === 'approved'),
    then: (schema) => schema.required().moreThan(0, 'Inspection Result required'),    
  }),            
  inspectionResultIdAttachmentName: Yup.string().trim().label(''),
  labTestAttachmentId: Yup.number().integer().label('Lab Test Result')
  .when('workflow', {
    is: (workflow: string) => (workflow === 'TriggerTest'),
    then: (schema) => schema.required().moreThan(0,'Lab Test required'),
  }),            
  labTestAttachmentIdAttachmentName: Yup.string().trim().label(''),
  inspectorAgree: Yup.bool().label('Confirmation')
  .when('workflow', {
    is: (workflow: string) => (workflow === 'TriggerTest'),    
    then: (schema) => schema.oneOf([true], 'Must be checked'),    
  }),
}).concat(billingDetailsSchema);

export const DLMTestResultForm = () => {

  const { values, setFieldValue, validateForm } = useFormikContext();
  const verdict = getIn(values, 'verdict') ?? '';
  const workflow = getIn(values, 'workflow') ?? '';

  useEffect(() => {        
    setFieldValue('billingRequired', (workflow !== 'TriggerTest' && verdict && ['approved','rejected'].includes(verdict)) ? 'YES' : 'NO', true);
    validateForm();
  }, [verdict, workflow, setFieldValue, validateForm]);

  return (
  <>
  { (verdict === 'approved' && ['Label1b1','Label1b2','Label5','MandatoryDOC1B'].includes(workflow)) &&
  <>
  <div className="row mb-2">        
    <FormikDateSelector size="6" label="Inspection Date" name="inspectionDate" required={verdict === 'approved'} showShiftSelector={true}  dateFormat='LL' />        
    <FormikFileUpload size="6" label="Inspection Result" name="inspectionResultId" acceptFiles="UserFileFormats" required={true} />
  </div>    
  </>
  }  
  { workflow === 'TriggerTest' && 
  <div className="row mb-2">        
   <FormikFileUpload size="12" label="Lab Test Attachment" name="labTestAttachmentId" acceptFiles="UserFileFormats"  required={true} />
  </div>    
  }      
  <FormikBillingDetails />    
  <FormikNotesArea required={(verdict !== 'approved')} />
  { (workflow === 'TriggerTest') && 
  <FormikInspectorAgreeCheck />
  }
  </>
  )
}